import {
  AuditReportsGipEvidenceExportOptionsDto,
  AuditReportsGipReportDataDto,
  AuditReportsPublicJobDtoStatusEnumKey,
  AuditReportsReportDto,
} from '@mi-front/api-v2';

export const GipReportDtoTypeEnum = {
  AUDIT_GIP_STATUS: 'AUDIT_GIP_STATUS',
} as const;

export const GipAltReportDtoTypeEnum = {
  AUDIT_GIP_ALTERNATIVE_REPORT: 'AUDIT_GIP_ALTERNATIVE_REPORT',
} as const;

type GipReportExportData = {
  status?: AuditReportsPublicJobDtoStatusEnumKey;
  options: AuditReportsGipEvidenceExportOptionsDto;
  jobId?: string;
  storageUri?: string;
};

type SavedGipReportConfig = Omit<AuditReportsGipReportDataDto, 'clientId'> & {
  clientId?: string;
};

type GipReportData = {
  config: SavedGipReportConfig;
  export?: GipReportExportData;
};

/** Saved standard GIP report returned by report endpoints. */
export type GipReportDto = AuditReportsReportDto & {
  type: (typeof GipReportDtoTypeEnum)[keyof typeof GipReportDtoTypeEnum];
  data: GipReportData;
};

/** Saved alternative GIP report returned by report endpoints. */
export type GipAltReportDto = AuditReportsReportDto & {
  type: (typeof GipAltReportDtoTypeEnum)[keyof typeof GipAltReportDtoTypeEnum];
  data: GipReportData;
};
